export default "__VITE_ASSET__DtaghGkL__"